import { type Enum } from '@webapp/infrastructure/types/Enum'

export const EditVarianceType = {
  DOLLAR: 'dollar',
  PERCENTAGE: 'percentage',
} as const

export type EditVarianceTypeEnum = Enum<typeof EditVarianceType>
